import React, { useEffect, useState } from 'react';
import type { OperationsTvRow } from './types';
import OperationsTvRowCard from './OperationsTvRow';

const OperationsTvTable: React.FC<{
  rows: OperationsTvRow[];
  loading: boolean;
  tvMode: boolean;
}> = ({ rows, loading, tvMode }) => {
  const [useEntryAnimation, setUseEntryAnimation] = useState(true);

  useEffect(() => {
    if (!rows.length) return undefined;
    const timer = window.setTimeout(() => setUseEntryAnimation(false), 1200);
    return () => window.clearTimeout(timer);
  }, [rows.length]);

  if (loading) {
    return (
      <div className="rounded-3xl border border-amber-300/30 bg-[linear-gradient(145deg,rgba(4,10,22,0.92),rgba(2,7,18,0.95))] p-10 shadow-[0_24px_70px_rgba(2,6,23,0.72)]">
        <div className="mx-auto h-11 w-11 animate-spin rounded-full border-2 border-amber-300 border-t-transparent" />
        <p className="mt-4 text-center text-[11px] font-black uppercase tracking-[0.24em] text-slate-300">Synchronizing Operations Board</p>
      </div>
    );
  }

  if (!rows.length) {
    return (
      <div className="rounded-3xl border border-amber-300/30 bg-[linear-gradient(145deg,rgba(4,10,22,0.92),rgba(2,7,18,0.95))] p-10 text-center shadow-[0_24px_70px_rgba(2,6,23,0.72)]">
        <p className="text-[11px] font-black uppercase tracking-[0.26em] text-amber-300">No Active Aircraft</p>
        <p className="mt-2 text-sm font-semibold text-slate-300">Fleet feed returned no rows. Keep this monitor active for live updates.</p>
      </div>
    );
  }

  return (
    <div className="ops-tv-glass-panel overflow-hidden rounded-3xl border border-amber-300/30 bg-[linear-gradient(135deg,rgba(4,9,21,0.95),rgba(3,7,18,0.96))] shadow-[0_26px_80px_rgba(2,6,23,0.8)]">
      <div className={`${tvMode ? 'max-h-[calc(100vh-340px)] ops-tv-scrollbar-none' : 'max-h-[64vh]'} overflow-auto`}>
        <table className="w-full min-w-[1240px] text-left">
          <thead className="sticky top-0 z-10 border-b border-amber-200/20 bg-[linear-gradient(90deg,rgba(15,25,54,0.99)_0%,rgba(10,18,39,0.99)_100%)] shadow-[inset_0_-1px_0_rgba(251,191,36,0.1)]">
            <tr>
              {['Aircraft', 'Current Location', 'Status', 'From → To', 'Pilot', 'Last Update', 'ETA'].map((head) => (
                <th
                  key={head}
                  className={`px-4 ${tvMode ? 'py-4 text-[11px]' : 'py-3 text-[10px]'} font-black uppercase tracking-[0.2em] text-amber-100/90 ${
                    head === 'ETA' ? 'text-right pr-6' : ''
                  }`}
                >
                  {head}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, idx) => (
              <OperationsTvRowCard key={row.aircraftId} row={row} tvMode={tvMode} rowIndex={idx} animateIn={useEntryAnimation} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default React.memo(OperationsTvTable);
